(function () {
  if (window.santaComparisonTrackingInitialized) return;
  window.santaComparisonTrackingInitialized = true;

  const META_PIXEL_ID = '1642603806774287';
  const GOOGLE_ADS_ID = 'AW-18154541104';
  const GOOGLE_ADS_CONVERSION_ID = 'AW-18154541104/E8EPCNvT9M0cELCg4dBD';
  const SELECTOR = '[data-comparison-view-trigger="true"]';
  let hasTrackedComparison = false;
  let pendingTarget;
  let observer;
  let privacyReady = false;

  const appendScript = src => {
    if (document.querySelector(`script[src="${src}"]`)) return;

    const script = document.createElement('script');
    script.async = true;
    script.src = src;
    document.head.appendChild(script);
  };

  const isMarketingAllowed = () => {
    const customerPrivacy = window.Shopify?.customerPrivacy;

    return typeof customerPrivacy?.marketingAllowed === 'function'
      && customerPrivacy.marketingAllowed();
  };

  const ensureMetaPixel = () => {
    if (typeof window.fbq !== 'function') {
      const fbq = function () {
        if (fbq.callMethod) {
          fbq.callMethod.apply(fbq, arguments);
        } else {
          fbq.queue.push(arguments);
        }
      };

      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      window.fbq = fbq;
      window._fbq = fbq;
      appendScript('https://connect.facebook.net/en_US/fbevents.js');
    }

    window.fbq('set', 'autoConfig', false, META_PIXEL_ID);
    window.fbq('init', META_PIXEL_ID);
  };

  const ensureGoogleTag = () => {
    window.dataLayer = window.dataLayer || [];

    if (typeof window.gtag !== 'function') {
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
      appendScript(`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`);
      window.gtag('js', new Date());
    }

    window.gtag('config', GOOGLE_ADS_ID, { send_page_view: false });
  };

  const trackComparisonView = target => {
    if (hasTrackedComparison) {
      observer?.disconnect();
      return;
    }

    if (!isMarketingAllowed()) {
      pendingTarget = target;
      observer?.disconnect();
      return;
    }

    ensureMetaPixel();
    ensureGoogleTag();

    const {
      comparisonViewId = 'comparison_table',
      comparisonViewName = 'Santa TOEFL competitor comparison table',
      comparisonViewCategory = 'TOEFL Comparison',
      comparisonViewType = 'section'
    } = target.dataset;

    window.fbq('trackSingle', META_PIXEL_ID, 'ViewContent', {
      content_ids: [comparisonViewId],
      content_name: comparisonViewName,
      content_category: comparisonViewCategory,
      content_type: comparisonViewType
    });

    window.gtag('event', 'conversion', {
      send_to: GOOGLE_ADS_CONVERSION_ID,
      value: 2.0,
      currency: 'USD'
    });

    hasTrackedComparison = true;
    pendingTarget = undefined;
    target.dataset.comparisonViewSent = 'true';
    observer?.disconnect();
  };

  const initComparisonTracking = () => {
    if (!privacyReady || hasTrackedComparison || pendingTarget) return;

    const targets = document.querySelectorAll(SELECTOR);
    if (targets.length === 0) return;

    if (!('IntersectionObserver' in window)) {
      trackComparisonView(targets[0]);
      return;
    }

    observer = observer || new IntersectionObserver(entries => {
      const visibleEntry = entries.find(entry => entry.isIntersecting && entry.intersectionRatio >= 0.25);
      if (visibleEntry) trackComparisonView(visibleEntry.target);
    }, {
      rootMargin: '0px 0px -15% 0px',
      threshold: [0.25]
    });

    targets.forEach(target => observer.observe(target));
  };

  const initPrivacy = () => {
    if (typeof window.Shopify?.customerPrivacy?.marketingAllowed === 'function') {
      privacyReady = true;
      initComparisonTracking();
      return;
    }

    if (typeof window.Shopify?.loadFeatures !== 'function') return;

    window.Shopify.loadFeatures([{
      name: 'consent-tracking-api',
      version: '0.1'
    }], error => {
      if (error || typeof window.Shopify?.customerPrivacy?.marketingAllowed !== 'function') return;

      privacyReady = true;
      initComparisonTracking();
    });
  };

  document.addEventListener('visitorConsentCollected', () => {
    if (pendingTarget) trackComparisonView(pendingTarget);
  });

  document.addEventListener('shopify:section:load', initComparisonTracking);

  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(SELECTOR).forEach(target => {
      observer?.unobserve(target);
      if (pendingTarget === target) pendingTarget = undefined;
    });
  });

  initPrivacy();
})();
